module.exports = __webpack_public_path__ + "static/img/SDL@2x.91ac124.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/UI_mock/2x/SDL@2x.png
// module id = vbZU
// module chunks = 1